import { createSlice } from "@reduxjs/toolkit";
import { CustomersFileType } from "../Common/Types/types";
import { RootState } from "../Core/Store";

const getInitialState = () => {
  return {
    isFolder: false,
    path: "",
    url: "",
    name: "",
  };
};

export const initialState: any = getInitialState();

const CustomersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    updateCustomersParams: (state = initialState, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateCustomersParams: updateCustomersParams } =
  CustomersSlice.actions;

export const getCustomersSelector = (state: RootState) => state.customers;

export default CustomersSlice.reducer;
